import classNames from "lib/classNames";
import ReactAnimatedNumber from "@crossfox/react-animated-number";
import { useRef } from "react";
import Icon from "hardcover-ui/components/Icon";
import checkmark from "icons/solid/check.svg";

interface Props {
  className?: string;
  progress?: number;
}

export default function CircleBookProgress({
  className = "",
  progress = 0,
}: Props) {
  // const [lastProgress, setLastProgress] = useState(progress);
  const radius = 37;
  const circumference = 2 * Math.PI * radius;
  const progressRadius = (progress / 100) * circumference;
  const starsRef = useRef<HTMLParagraphElement>();

  // Todo: Add party js
  // let party;
  // if (typeof window !== "undefined" && typeof document !== "undefined") {

  // party = require("party-js");
  // }

  // useEffect(() => {
  //   if (
  //     party &&
  //     progress === 100 &&
  //     lastProgress !== 100 &&
  //     starsRef.current &&
  //     starsRef.current.checkVisibility
  //   ) {
  //     const isVisible = starsRef.current.checkVisibility({
  //       checkOpacity: true,
  //       checkVisibilityCSS: true,
  //     });
  //     if (isVisible) {
  //       setLastProgress(progress);
  //       party.default.sparkles(starsRef.current, {
  //         count: party.default.variation.range(20, 30),
  //         speed: party.default.variation.range(50, 150),
  //         size: party.default.variation.range(0.5, 1.5),
  //       });
  //     }
  //   }
  // }, [progress]);

  return (
    <div className={classNames(className, "w-24")}>
      <div
        className="flex justify-center items-center w-20 h-20 relative rounded-full shrink-0"
        role="slider"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={progress}
        tabIndex={0}
      >
        <svg className="absolute w-full h-full fill-background bg-background rounded-full">
          <circle
            cx="50%"
            cy="50%"
            r={radius}
            strokeWidth="6"
            className="stroke-secondary fill-none"
            fill="none"
            vectorEffect="non-scaling-stroke"
          />
          <circle
            cx="75%"
            cy="50%"
            r={radius}
            strokeWidth="6"
            className="stroke-success fill-none transition-all ease-in-out duration-500"
            strokeDasharray={circumference}
            strokeDashoffset={circumference - progressRadius}
            transform="rotate(-90 50 50)"
          />
        </svg>
        <p
          ref={starsRef}
          className={classNames(
            progress >= 100 ? "text-success" : "",
            "z-10 text-lg font-bold pointer-events-none select-none text-center leading-4"
          )}
        >
          <span className="lg:hidden">
            <Icon
              icon={checkmark}
              size="2xl"
              className={progress >= 100 ? "text-success" : ""}
            />
          </span>
          <span className="hidden lg:inline">
            <ReactAnimatedNumber
              tagName="span"
              value={progress > 100 ? 100 : progress}
              duration={1000}
              suffix="%"
            />
            <br />
            <span
              className={`text-sm ${progress >= 100 ? "text-success" : "text-secondary"
                }`}
            >
              Done
            </span>
          </span>
        </p>
      </div>
    </div>
  );
}
